export default "__VITE_ASSET__DioL7PzY__"